<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <div class="inline-icon" inlineSVG="shop-icons.svg#ya-waiterpay"></div>
    <h2 langkey="phBasketPay_WaiterDialog_Title"></h2>
    <div class="table-number-info">
      <h3>{{tableInfo}}</h3>
    </div>
    <div class="divider"></div>
    <div>
      <span langkey="phBasketPay_WaiterDialog_Description"></span>
    </div>
    <div>
      <div class="container">
        <div class="qrcode-container">
          <div class="qrcode-svg-wrapper">
            <div class="qr-code" [innerHTML]="posTableNumberQrCodeSvg"></div>
          </div>
        </div>
      </div>
      <span class="table-number">{{posTableNumber}}</span>
    </div>
    <div class="botton-wrapper">
      <div class="ya-webshop-button-container">
        <button mat-flat-button (click)="BackBtn()">
          <span langkey="phBasketPay_OptionDialog_Back_Btn"></span>
        </button>
      </div>
    </div>
  </div>
</div>